import { FC } from 'react'
import { DevTool } from 'src/features/development'
import { useDevelopmentHooks } from 'src/features/development/hooks'

const devToolStyle = {
  // backgroundImage: `url(${'/atoms/shoes/spike_front.jpg'})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'left -35px top 0px',
  backgroundSize: '105%',
  maxWidth: '100%'
}

type Props = {
  frontSurfaceId: string
  maxWidth?: '100%' | '65%' | '50%' | '40%'
}

export const FrontSurface: FC<Props> = ({ frontSurfaceId, maxWidth = '100%' }) => {
  const { devFlg, devTools, handleCoordinate } = useDevelopmentHooks()
  return (
    <>
      {devFlg === 'true' ? (
        <div>
          <canvas width={880} height={680} id={frontSurfaceId} style={{ ...devToolStyle }} onClick={(e) => handleCoordinate(e)} />
          <DevTool devTools={devTools} />
        </div>
      ) : (
        <canvas id={frontSurfaceId} width={880} height={680} style={{ maxWidth }} />
      )}
    </>
  )
}
